import React, {useState} from 'react';

import {CATEGORY, EDITORIAL, PODCAST} from 'src/routes/paths';
import {ChiefLogo} from 'src/svgs/chiefLogo';
import {ArticlesListProps} from 'src/templates/articlesHomepage';

import {GridCardSmall} from './GridCardSmall';

type CategoriesFeatureModuleProps = Pick<ArticlesListProps, 'topics'>;

export const CategoriesFeatureModule: React.FC<CategoriesFeatureModuleProps> = ({
  topics,
}: CategoriesFeatureModuleProps) => {
  const [currentTopicIndex, setCurrentTopicIndex] = useState(0);

  const Categories = topics?.map((item, index) => {
    if (item?.hideFromNav != true) {
      return (
        <button
          key={index}
          onClick={() => setCurrentTopicIndex(index)}
          className={`all-categories-btn button-white-sheer self-end ${index === currentTopicIndex && 'active'}`}
        >
          <span>{item?.title}</span>
        </button>
      );
    }
  });
  const currentArticles = () => {
    const currentTopic = topics[currentTopicIndex];
    return (
      <div className="col-span-full grid grid-cols-4 md:grid-cols-12 gap-8">
        <div className="col-span-full md:col-span-6 all-categories-featured active">
          <a
            href={`${currentTopic?.featuredArticles?.featuredArticle?.isPodcast ? PODCAST : EDITORIAL}/${
              currentTopic?.featuredArticles?.featuredArticle?.slug?.current
            }`}
            className="bg-black grid w-full lg:h-[400px] relative"
          >
            {currentTopic?.featuredArticles?.featuredArticle?.heroImage?.asset?.url ? (
              <img
                className="object-cover w-full h-full"
                src={currentTopic?.featuredArticles?.featuredArticle?.heroImage?.asset?.url || ''}
                alt={currentTopic?.featuredArticles?.featuredArticle?.heroImage?.asset?.altText || ''}
              ></img>
            ) : (
              <div className="absolute w-full h-full object-cover bg-black flex items-center justify-center">
                <ChiefLogo classes={'mb-2 lg:mb-0 h-[18px] lg:w-25 lg:h-[8%] fill-light-gold'} />
              </div>
            )}
          </a>

          <div>
            {currentTopic?.featuredArticles?.featuredArticle?.editorialCategory?.slug ? (
              <a
                href={`${CATEGORY}/${currentTopic?.featuredArticles?.featuredArticle?.editorialCategory?.slug.current}`}
                className="type-eyebrow mt-5 md:mt-7 block text-white eyebrow-link"
              >
                {currentTopic?.featuredArticles?.featuredArticle?.editorialCategory?.title}
              </a>
            ) : (
              currentTopic?.featuredArticles?.featuredArticle?.editorialCategory?.title && (
                <span className="type-eyebrow mt-5 md:mt-7 block text-white">
                  {currentTopic?.featuredArticles?.featuredArticle?.editorialCategory?.title}
                </span>
              )
            )}

            <h3 className="type-gamma text-white mt-1 md:mt-2">
              <a
                href={`${currentTopic?.featuredArticles?.featuredArticle?.isPodcast ? PODCAST : EDITORIAL}/${
                  currentTopic?.featuredArticles?.featuredArticle?.slug?.current
                }`}
                className="link-text-white"
              >
                {currentTopic?.featuredArticles?.featuredArticle?.title}
              </a>
            </h3>
          </div>
        </div>
        <div className="col-span-full md:col-span-6 lg:ml-3">
          <div className="grid grid-cols-1 gap-y-6">
            <GridCardSmall
              article={currentTopic?.featuredArticles?.firstArticle}
              titleClasses={'link-text-white text-white'}
            />
            <GridCardSmall
              article={currentTopic?.featuredArticles?.secondArticle}
              titleClasses={'link-text-white text-white'}
            />
            <GridCardSmall
              article={currentTopic?.featuredArticles?.thirdArticle}
              titleClasses={'link-text-white text-white'}
            />
          </div>

          {currentTopic?.relatedBenefitCta && (
            <div data-module="banner-icon-cta module-spacing">
              <div className="bg-green-dark">
                <div className="grid grid-cols-4 lg:gap-8 py-6 lg:py-7 items-center">
                  <div className="col-span-full all-categories-cta  active ">
                    <div className="flex flex-col sm:flex-wrap md:flex-row items-baseline justify-start">
                      <div className="min-w-max flex flex-row items-baseline">
                        <span aria-hidden="true" className="w-5 h-5 mr-2">
                          <img
                            src={currentTopic?.relatedBenefitCta?.icon?.asset?.url || ''}
                            alt={currentTopic?.relatedBenefitCta?.icon?.asset?.altText || ''}
                          ></img>
                        </span>
                        <span className="sr-only">CHIEF</span>
                        <svg
                          className="mb-2 md:mb-0 md:pr-2 h-[18px] lg:w-25 lg:h-5 fill-white"
                          viewBox="0 0 109 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M53.9167 20.1444H56.8131V0.845868H53.9167V20.1444ZM41.9652 0.845868H44.8615V20.1444H41.9652V11.9688H29.9035V20.1444H27.0062V0.845868H29.9035V9.0214H41.9679L41.9652 0.845868ZM65.8701 0.845868V20.1444H83.0046V17.1988H68.7601V11.9688H80.5514V9.02316H68.7601V3.79062H82.9956V0.845868H65.8682H65.8701ZM94.7624 3.79062V9.0214H106.554V11.967H94.7624V20.1426H91.8663V0.84409H109V3.79062H94.7624ZM17.0665 13.6877C16.4679 14.9909 15.5164 16.0936 14.3235 16.8667C13.1305 17.6398 11.7457 18.0512 10.331 18.0526C8.36112 18.0495 6.47278 17.2526 5.07984 15.8364C3.68691 14.42 2.90299 12.5 2.89992 10.4971C2.90324 8.49427 3.68722 6.57412 5.0801 5.15789C6.47299 3.74165 8.36119 2.94457 10.331 2.9412C11.7461 2.94304 13.1314 3.35497 14.3244 4.12889C15.5174 4.90281 16.4685 6.00691 17.0665 7.311L19.6915 6.06643C18.8596 4.25533 17.5372 2.72302 15.8794 1.64862C14.2216 0.57422 12.297 0.002171 10.331 0C7.59334 0.00288718 4.96847 1.10925 3.03188 3.07678C1.09528 5.04429 0.00497572 7.71266 0 10.4962C0.00284408 13.2812 1.09221 15.9513 3.02904 17.9206C4.96586 19.8899 7.59194 20.9971 10.331 21C12.297 20.9979 14.2216 20.4262 15.8794 19.3518C17.5372 18.2775 18.8596 16.7452 19.6915 14.934L17.0665 13.6877Z"></path>
                        </svg>
                      </div>
                      <span className="type-zeta text-light-gold">on {currentTopic?.relatedBenefitCta?.name}</span>
                    </div>
                    <div className="type-sm-p lg:type-p mt-3 text-white">
                      {currentTopic?.relatedBenefitCta?.benefitDescription}
                    </div>

                    {currentTopic?.relatedBenefitCta?.cta && currentTopic?.relatedBenefitCta?.cta[0]?.href && (
                      <div className="mt-5 col-span-full lg:col-start-10 lg:col-span-2">
                        <a
                          href={currentTopic?.relatedBenefitCta?.cta[0]?.href || ''}
                          className="button"
                          target={currentTopic?.relatedBenefitCta?.cta[0]?.target || ''}
                        >
                          {currentTopic?.relatedBenefitCta?.cta[0]?.buttonText}
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <section className="px-gutter module-spacing bg-green-dark" data-module="all-categories-feature">
      <div className="wrapper-default grid grid-cols-4 md:grid-cols-12 lg:gap-x8">
        <div className="col-span-full flex items-center justify-center flex-wrap space-x-3 md:space-x-5 space-y-3 md:space-y-5 mb-9 lg:mb-12">
          {Categories}
        </div>

        {currentArticles()}
      </div>
    </section>
  );
};
